import React, {Component} from 'react';
import { Card, CardHeader, CardBody, Input, InputGroup, InputGroupAddon, Button } from 'reactstrap';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import md5 from 'md5';

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';
import filterFactory, { textFilter, numberFilter } from 'react-bootstrap-table2-filter';

import ProductSearch from '../../components/Product/Search';
import ProductEditor from '../../components/Product/Editor';

import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import './List.css';

import Config from '../../config';

class ProductList extends Component {
 constructor(props) {
  super(props);

  this.state = {
   page: 1,
   data: [],
   passwd: '',
   product: null,
   totalSize: 0,
   sizePerPage: 10,
   editorWindow: false,
   selected: []
  };
  
  this.filters = {};
  this.columns = [
   { dataField: 'name', text: 'Nombre', filter: textFilter({ getFilter: (filter) => { this.filters.name = filter } }), headerStyle: () => { return { width: '50%' } }, sort: true },
   { dataField: 'price', text: 'Precio IVA incl.', filter: numberFilter({ getFilter: (filter) => { this.filters.price = filter } }), sort: true, formatter: (cellContent, row) => { return parseFloat(cellContent).toFixed(2) } },
   {
    dataField: 'tax', text: 'IVA', filter: numberFilter({ getFilter: (filter) => { this.filters.tax = filter } }), sort: true, formatter: (cellContent, row) => { return parseFloat(cellContent).toFixed(0)+'%' }, 
    editor: { type: Type.SELECT, options: [{ value: '1', label: '21% IVA' }, { value: '2', label: '10% IVA' }, { value: '3', label: '4% IVA' }, { value: '0', label: 'Sin IVA' }] }
   },
   { dataField: 'stock', text: 'Stock', filter: numberFilter({ getFilter: (filter) => { this.filters.stock = filter } }), sort: true },
   { dataField: 'ID', text: 'Acciones', headerStyle: () => { return { width: '108px' } }, headerFormatter:() => (
    <Button className="float-right" title="Restablecer filtros" onClick={this.resetFilters}><i className="fa fa-filter"></i>&nbsp;Limpiar</Button>
   ), formatter: (cellContent, row) => (
    <div className="checkbox disabled">
     <Button color="primary" onClick={() => this.openEditor(cellContent)}><i className="fa fa-edit"></i></Button>
     {' '}
     <Button color="danger" onClick={() => this.doDelete(cellContent)}><i className="fa fa-trash"></i></Button>
    </div>
   )}
  ];


  this.doDelete = this.doDelete.bind(this);

  this.openEditor = this.openEditor.bind(this);
  this.closeEditor = this.closeEditor.bind(this);

  this.resetFilters = this.resetFilters.bind(this);

  this.handleOnSelect = this.handleOnSelect.bind(this);
  this.handleOnSelectAll = this.handleOnSelectAll.bind(this);
  this.handleTableChange = this.handleTableChange.bind(this);
  this.handleClickDelete = this.handleClickDelete.bind(this);

  this.lastRequest = {}
 }

 resetFilters() {
  this.filters.name('');
  this.filters.price('');
  this.filters.stock('');
 }

 handleOnSelect(row, isSelect, rowIndex, e) {
  if (isSelect) {
   this.setState({ selected: [...this.state.selected, row.ID] });
  } else {
   this.setState({ selected: this.state.selected.filter(x => x !== row.ID) });
  }
 }

 handleOnSelectAll(isSelect, rows, e) {
  const IDs = rows.map(r => r.ID);
  if (isSelect) {
   this.setState({ selected: [...this.state.selected, ...IDs] });
  } else {
   this.setState({ selected: this.state.selected.filter((e) => { return IDs.indexOf(e) < 0 }) });
  }
 }

 handleTableChange(type, { page, sizePerPage, filters, sortField, sortOrder, cellEdit }) {
  if (type !== 'cellEdit') {
   this.lastRequest = { page, sizePerPage, sortField, sortOrder, filters };
   this.props.reqAPI(Config.apiURI+'/api/products', 'POST', this.lastRequest).then(data => {
    this.setState(() => ({ page, data: data.items, totalSize: data.total, sizePerPage, filters, sortField, sortOrder }));
   }).catch((error) => {
    console.log(error);
   });
  } else {
   this.props.reqAPI(Config.apiURI+'/api/products', 'PUT', cellEdit).then((result) => {
    var newItems = this.state.data;
    for(var i = 0; i < newItems.length; i += 1) {
     if(newItems[i].ID === result.ID) newItems[i] = result;
    }

    this.setState({data: newItems});
   }).catch((error) => {
    console.log(error);
   })
  }
 }


 handleClickDelete(IDs, onClose) {
  this.props.reqAPI(Config.apiURI+'/api/products/delete', 'POST', {
   products: IDs,
   passwd: md5(this.state.passwd)
  }).then(result => {
   onClose();
   if(!result.success) {
    this.doDelete(IDs, true);
    if(result.message) toast.error(result.message);
   } else {
    toast.success(IDs.length > 1 ? 'Los productos han sido eliminados' : 'El producto ha sido eliminado');
    this.setState({ selected: this.state.selected.filter((e) => { return IDs.indexOf(e) < 0 }) });
    this.handleTableChange('reload', {
     page: this.state.page,
     sizePerPage: this.state.sizePerPage,
     filters: this.state.filters,
     sortField: this.state.sortField,
     sortOrder: this.state.sortOrder
    });
   }
  }).catch((error) => {
   console.log(error);
  });
 }


 doDelete(ID, error = false) {
  var IDs = ID === null ? this.state.selected : typeof(ID) === 'object' ? ID : [ ID ];
  confirmAlert({
   customUI: ({ onClose }) => {
    return (
     <Card className='confirm-delete alert-danger'>
      <CardBody>
       <h2>Atención!</h2>
       <p>{IDs.length == 1 ? 'Se va a borrar un producto.' : 'Se van a borrar '+IDs.length+' productos.'}</p>
       <p><strong>Esta operación no podrá ser revertida. Desea continuar?</strong></p>
       <InputGroup>
        <Input type="password" autoComplete="new-password" placeholder="Confirme con su clave"
         onKeyPress={(event) => { if(event.key === 'Enter') this.handleClickDelete(IDs, onClose); }}
         onChange={(e) => { this.setState({passwd: e.target.value}); }}
         className={error ? 'border border-danger' : ''}
         defaultValue={this.state.passwd}
        />
        <InputGroupAddon addonType="append">
         <Button color="danger" onClick={() => { this.handleClickDelete(IDs, onClose); }}>Si, eliminar!</Button>
         <Button color="primary" onClick={onClose}>No, cancelar!</Button>
        </InputGroupAddon>
       </InputGroup>
      </CardBody>
     </Card>
    );
   }
  });
 }


 openEditor(ID) {
  if(ID === null) {
   this.setState({product: null}, function() {
    this.setState({editorWindow: true});
   });
  } else {
   this.props.reqAPI(Config.apiURI+'/api/products/'+ID+'?full').then(product => {
    this.setState({product: product}, function() {
     this.setState({editorWindow: true});
    });
   })
  }
 }

 closeEditor(state) {
  if(state) toast.success('Los cambios han sido guardados');
  this.setState({product: null, editorWindow: false});
  this.handleTableChange('reload', {
   page: this.state.page,
   sizePerPage: this.state.sizePerPage,
   filters: this.state.filters,
   sortField: this.state.sortField,
   sortOrder: this.state.sortOrder
  });
 }

 

 render() {
  return (
   <Card>
    <CardHeader>
     <ProductSearch reqAPI={this.props.reqAPI} handleInputEL={()=> (console.log())} handleCallback={(e)=> (this.openEditor(e.ID))} />
    </CardHeader>

    <CardBody>
     <Button color="success" onClick={() => this.openEditor(null)}><i className="fa fa-plus"></i> Nuevo producto</Button>
     {' '}
     {this.state.selected.length > 0 ? <Button color="danger" onClick={() => this.doDelete(null)}><i className="fa fa-minus"></i> Eliminar seleccionados</Button> :''}

     <BootstrapTable
      remote
      striped
      condensed
      bootstrap4
      keyField="ID"
      bordered={ false }
      data={ this.state.data }
      columns={ this.columns }
      selectRow={{
       mode: 'checkbox',
       onSelect: this.handleOnSelect,
       onSelectAll: this.handleOnSelectAll
      }}
      defaultSorted={ [{
       dataField: 'name',
       order: 'asc'
      }] }
      filter={ filterFactory() }
      pagination={
       paginationFactory({
        page: this.state.page,
        sizePerPage: this.state.sizePerPage,
        sizePerPageList: [
         { text: '5', value: 5 },
         { text: '10', value: 10 },
         { text: '25', value: 25 },
         { text: '50', value: 50 },
         { text: '100', value: 100 }
        ],
        showTotal: true,
        totalSize: this.state.totalSize,
        firstPageText: '<<',
        prePageText: '<',
        nextPageText: '>',
        lastPageText: '>>',
        nextPageTitle: 'Página primera',
        prePageTitle: 'Página anterior',
        firstPageTitle: 'Página siguiente',
        lastPageTitle: 'Última página',
        paginationTotalRenderer: (from, to, size) => (
         <span className="react-bootstrap-table-pagination-total">
          &nbsp;Mostrando del <strong>{ from } al { to }</strong> de un total de <strong>{ size } productos</strong>
         </span>
        )
       })
      }
      cellEdit={
       cellEditFactory({
        mode: 'dbclick'
       })
      }
      onTableChange={ this.handleTableChange }
      noDataIndication="No se han encontrado resultados"
     />
    </CardBody>

    <ProductEditor reqAPI={this.props.reqAPI} open={this.state.editorWindow} product={this.state.product} handleClose={this.closeEditor} onComplete={this.closeEditor} />
   </Card>
  )
 }
}

export default ProductList;



// WEBPACK FOOTER //
// ./src/views/Products/List.js